module.exports = require("/Users/pmoalmeida/EnigmaticSmile/website/src/store")